<template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 billing-address">
        <div class="white_box">
            <h1 class="heading1">5. Billing Address</h1>
            
            <!-- Billing Address Selection -->
            <div class="billing-address-section pt-3">
                <h3 class="mb-3">Billing Address</h3>
                
                <!-- Address Dropdown -->
                <div class="form-group choose_billing_address">
                    <label class="select_option_label">Choose a Billing Address</label>
                    <v-select
                        v-if="reloadAddressSelect"
                        autocomplete="on"
                        label="address"
                        :reduce="(address) => address.id"
                        :options="billingAddresses"
                        placeholder="Select Billing Address"
                        v-model="selectedBillingAddressId"
                        :clearable="true"
                    ></v-select>
                </div>

                <!-- Add New Address Button -->
                <div class="">
                    <button
                        type="button"
                        class="btn btn-link text_primary_blue p-0"
                        @click="addNewAddress"
                    >
                        + Add New Address
                    </button>
                </div>

                <!-- Add/Edit Address Form -->
                <div v-if="showAddressForm" class="address-form-section mt-4">
                    <form @submit.prevent="saveAddress" name="billingAddressForm" data-vv-scope="billingAddressForm">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label>Address Title (Optional)</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="currentAddress.address_title"
                                        placeholder="Enter Address Title"
                                    />
                                    <span class="highlight"></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label>Name*</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="currentAddress.fullname"
                                        name="fullname"
                                        v-validate="'required'"
                                        placeholder="Enter Name"
                                    />
                                    <span class="highlight"></span>
                                    <small class="form-text text-error text-left" v-show="errors.has('billingAddressForm.fullname')">
                                        {{ errors.first('billingAddressForm.fullname') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label>Company Name (Optional)</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="currentAddress.company_name"
                                        placeholder="Enter Company Name"
                                    />
                                    <span class="highlight"></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label>Phone No*</label>
                                    <input
                                        type="tel"
                                        class="form-control"
                                        v-model="currentAddress.phone"
                                        name="phone"
                                        v-validate="'required'"
                                        placeholder="Enter Phone Number"
                                    />
                                    <span class="highlight"></span>
                                    <small class="form-text text-error text-left" v-show="errors.has('billingAddressForm.phone')">
                                        {{ errors.first('billingAddressForm.phone') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label class="add1">Address 1*</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="currentAddress.address_line1"
                                        name="address_line1"
                                        v-validate="'required'"
                                        placeholder="Enter Address 1"
                                    />
                                    <span class="highlight"></span>
                                    <small class="form-text text-error text-left" v-show="errors.has('billingAddressForm.address_line1')">
                                        {{ errors.first('billingAddressForm.address_line1') }}
                                    </small>
                                    <div v-if="address1_suggestion" class="address-suggestion mt-2">
                                        <small class="text-info">
                                            <strong>Suggested Address 1:</strong> {{ address1_suggestion }}
                                            <button type="button" class="btn btn-sm btn-link p-0 ml-2" @click="applyAddress1Suggestion">
                                                Use this
                                            </button>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const">
                                    <label class="add1">Address 2</label>
                                    <textarea
                                        class="form-control"
                                        v-model="currentAddress.address_line2"
                                        placeholder="Enter Address 2"
                                        rows="2"
                                    ></textarea>
                                    <span class="highlight"></span>
                                    <div v-if="address2_suggestion" class="address-suggestion mt-2">
                                        <small class="text-info">
                                            <strong>Suggested Address 2:</strong> {{ address2_suggestion }}
                                            <button type="button" class="btn btn-sm btn-link p-0 ml-2" @click="applyAddress2Suggestion">
                                                Use this
                                            </button>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group label-const">
                                    <label>City*</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="currentAddress.city"
                                        name="city"
                                        v-validate="'required'"
                                        placeholder="Enter City"
                                    />
                                    <span class="highlight"></span>
                                    <small class="form-text text-error text-left" v-show="errors.has('billingAddressForm.city')">
                                        {{ errors.first('billingAddressForm.city') }}
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="select_option_label bill_state">State*</label>
                                    <v-select
                                        v-if="reloadStateInput"
                                        autocomplete="off"
                                        label="code"
                                        :reduce="(name) => name.code"
                                        :options="all_states"
                                        placeholder="Select State"
                                        name="state"
                                        v-model="currentAddress.state"
                                        v-validate="'required'"
                                        :clearable="true"
                                    ></v-select>
                                    <small class="form-text text-error text-left" v-show="errors.has('billingAddressForm.state')">
                                        {{ errors.first('billingAddressForm.state') }}
                                    </small>
                                    <small class="form-text text-error text-left font-weight-bold" v-if="state_suggestion">
                                        Suggestion: {{ state_suggestion }}
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group label-const">
                                    <label>Zip*</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="currentAddress.zip"
                                        name="zip"
                                        v-validate="'required'"
                                        placeholder="Enter Zip Code"
                                    />
                                    <span class="highlight"></span>
                                    <small class="form-text text-error text-left" v-show="errors.has('billingAddressForm.zip')">
                                        {{ errors.first('billingAddressForm.zip') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="select_option_label">Country</label>
                                    <v-select
                                        v-if="reloadCountryInput"
                                        autocomplete="off"
                                        label="name"
                                        :reduce="(country) => country.code"
                                        :options="all_countries"
                                        placeholder="Select Country"
                                        name="Country"
                                        v-model="currentAddress.country"
                                        :clearable="true"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group label-const">
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        class="form-control"
                                        v-model="currentAddress.email"
                                        placeholder="Enter Email"
                                    />
                                    <span class="highlight"></span>
                                </div>
                            </div>
                        </div>

                        <div class="form-actions mt-4 d-flex justify-content-end">
                            <button
                                type="button"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46 mr-2"
                                @click="cancelEdit"
                            >
                                CANCEL
                            </button>
                            <button
                                type="submit"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_64 save-width"
                                style="width: fit-content !important;"
                                :disabled="isSaving"
                            >
                                SAVE
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Order Comment Section -->
                <div class="order-comment-section mt-0">
                    <p class="mb-0">
                        If you would like to add a comment about your order, please write it in the field below.
                    </p>
                    <textarea
                        v-if="order_data"
                        class="form-control"
                        v-model="order_data.billing_order_comment"
                        rows="4"
                        placeholder="Enter your order comment here..."
                    ></textarea>
                </div>
            </div>
        </div>

        <!-- Full-page style loader during USPS verify + save (same pattern as split shipping addresses) -->
        <div class="preloader" v-show="isSaving">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "BillingAddress",
    props: {
        order_data: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            billingAddresses: [],
            selectedBillingAddressId: null,
            currentAddress: {
                address_title: "",
                fullname: "",
                company_name: "",
                phone: "",
                email: "",
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                zip: "",
                country: "US",
                is_default: false
            },
            editingAddressIndex: null,
            showAddressForm: false,
            all_states: [],
            all_countries: [],
            reloadStateInput: true,
            reloadCountryInput: true,
            reloadAddressSelect: true,
            address1_suggestion: "",
            address2_suggestion: "",
            state_suggestion: "",
            /** Filled from /user-profile when parent order_data has no name/email yet (e.g. split billing step). */
            customerProfileDefaults: null,
            isSaving: false
        };
    },
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        /** Prefer explicit prop from Checkout; fall back to $parent for older call sites. */
        orderPayload() {
            return this.order_data || (this.$parent && this.$parent.order_data) || null;
        }
    },
    watch: {
        selectedBillingAddressId(newVal) {
            if (newVal) {
                if (this.isSplitShipment && typeof localStorage !== "undefined") {
                    try { localStorage.setItem("billingAddressIdSplit", String(newVal)); } catch (e) {}
                }
                this.loadBillingAddressToOrderData(newVal);
            }
        }
    },
    mounted() {
        this.loadStates();
        this.loadCountries();
        this.loadBillingAddresses();
        this.loadCustomerProfileDefaults();
    },
    methods: {
        capitalize(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        loadCustomerProfileDefaults() {
            ApiService.get("/user-profile")
                .then(({ data }) => {
                    const user = data && data.user;
                    if (!user) return;
                    let phone = user.mobile ? user.mobile : "";
                    if (user.Profile && user.Profile.phone_no) {
                        phone = user.Profile.phone_no;
                    }
                    const x = phone
                        .replace(/\D/g, "")
                        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    const formatted = !x || !x[2]
                        ? (x && x[1]) || ""
                        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
                    this.customerProfileDefaults = {
                        firstName: this.capitalize(user.first_name || ""),
                        lastName: this.capitalize(user.last_name || ""),
                        email: user.email || "",
                        phone: formatted
                    };
                    if (this.showAddressForm) {
                        this.applyCustomerDefaultsToBillingForm();
                    }
                })
                .catch(() => {
                    /* guest / network — leave defaults empty */
                });
        },
        loadStates() {
            ApiService.get("/states")
                .then(({ data }) => {
                    this.all_states = data.states || [];
                })
                .catch((error) => {
                    console.error("Error loading states:", error);
                });
        },
        loadCountries() {
            ApiService.get("/countries")
                .then(({ data }) => {
                    this.all_countries = data.countries || [];
                })
                .catch((error) => {
                    console.error("Error loading countries:", error);
                });
        },
        loadBillingAddresses() {
            // Load addresses from API - same as ShippingPayment.vue
            const _this = this;
            return ApiService.get("/addresses")
                .then((response) => {
                    if (response.data && response.data.address) {
                        const addresses = [];
                        let defaultAddressId = null;
                        response.data.address.forEach((elem) => {
                            const namePart = [elem.first_name, elem.last_name].filter(Boolean).join(" ") || elem.address_label || "";
                            const linePart = [elem.address1, elem.address2].filter(Boolean).join(", ");
                            const cityPart = [elem.city, elem.state, elem.pincode].filter(Boolean).join(", ");
                            let displayAddress = elem.address && elem.address.trim()
                                ? elem.address.replace(", ,", ",")
                                : [elem.address_label, namePart, linePart, cityPart].filter(Boolean).join(", ");
                            const title =
                                elem.address_title != null &&
                                String(elem.address_title).trim() !== ""
                                    ? String(elem.address_title).trim()
                                    : "";
                            if (title) {
                                displayAddress = displayAddress
                                    ? `${title}, ${displayAddress}`
                                    : title;
                            }
                            addresses.push({
                                id: elem.id,
                                address_type: elem.address_type,
                                address_label: elem.address_label,
                                address_title: elem.address_title,
                                first_name: elem.first_name,
                                last_name: elem.last_name,
                                address: displayAddress,
                                // Additional fields for form editing
                                address1: elem.address1 || "",
                                address2: elem.address2 || "",
                                city: elem.city || "",
                                state: elem.state || "",
                                pincode: elem.pincode || "",
                                country: elem.country || "US",
                                phone: elem.phone || "",
                                email: elem.email || ""
                            });
                            // Find default billing address
                            if (elem.address_type && elem.address_type.includes('Billing') && !defaultAddressId) {
                                defaultAddressId = elem.id;
                            }
                        });
                        _this.billingAddresses = addresses;
                        // Priority: 1) order_data (user came back from Payment/Review), 2) split default shipping, 3) localStorage, 4) API default, 5) single address
                        let idToSelect = null;
                        const od = _this.orderPayload;
                        const fromOrderData = od && (od.billing_address_id || od.billingaddressid);
                        if (fromOrderData && addresses.some(function (a) { return a.id == fromOrderData; })) {
                            idToSelect = fromOrderData;
                        }
                        if (!idToSelect && _this.isSplitShipment && _this.$store.state.splitShipment && _this.$store.state.splitShipment.splitAddresses) {
                            const defaultShipping = _this.$store.state.splitShipment.splitAddresses.find(function (a) { return a.is_default; });
                            const defaultShipId = defaultShipping && (defaultShipping.id || defaultShipping.address_id);
                            if (defaultShipId && addresses.some(function (a) { return a.id == defaultShipId; })) {
                                idToSelect = defaultShipId;
                            }
                        }
                        if (!idToSelect && _this.isSplitShipment && typeof localStorage !== "undefined") {
                            const fromLs = localStorage.getItem("billingAddressIdSplit");
                            if (fromLs && addresses.some(function (a) { return a.id == fromLs; })) {
                                idToSelect = fromLs;
                            }
                        }
                        if (!idToSelect && defaultAddressId) idToSelect = defaultAddressId;
                        if (!idToSelect && addresses.length === 1) idToSelect = addresses[0].id;
                        // Use actual option id (same type as in options) so v-select shows label not raw id
                        const resolvedOption = idToSelect != null ? addresses.find(function (a) { return a.id == idToSelect; }) : null;
                        _this.selectedBillingAddressId = resolvedOption ? resolvedOption.id : idToSelect;
                        _this.reloadAddressSelect = false;
                        _this.$nextTick(() => {
                            _this.reloadAddressSelect = true;
                            if (resolvedOption) _this.selectedBillingAddressId = resolvedOption.id;
                        });
                        return response;
                    }
                })
                .catch((error) => {
                    console.error("Error loading billing addresses:", error);
                    throw error;
                });
        },
        getAddressForForm(addressId) {
            // Get full address details for editing - similar to ShippingPayment.vue getAddress method
            return new Promise((resolve, reject) => {
                ApiService.post("/getstateandzipcode/" + addressId)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        normalizeCountryCode(country) {
            if (!country) return "US";
            const countryStr = country.toString().toUpperCase();
            if (countryStr.length === 2) return countryStr;
            // Map common country names to codes
            const countryMap = {
                "UNITED STATES": "US",
                "USA": "US",
                "UNITED KINGDOM": "GB",
                "UK": "GB",
                "CANADA": "CA"
            };
            return countryMap[countryStr] || countryStr.substring(0, 2);
        },
        async verifyAddressWithUSPS(address) {
            const params = {
                address1: address.address_line1 || address.address1 || "",
                address2: address.address_line2 || address.address2 || "",
                city: address.city || "",
                addressstate: address.state || "",
                addresszip: address.zip || address.pincode || ""
            };
            
            // Log for debugging
            
            // Validate required fields
            if (!params.address1 || !params.addressstate || !params.addresszip) {
                const errorMsg = "Address 1, State, and Zip are required for address verification";
                console.error("[BillingAddress] Missing required fields:", params);
                this.$toast.error(errorMsg, {
                    position: "top-right",
                    queue: true,
                    duration: 5000
                });
                return Promise.reject({ success: false, error: errorMsg });
            }
            
            this.resetSuggestions();
            return new Promise((resolve, reject) => {
                ApiService.post("/verifyAddress/usps", params)
                    .then(({ data }) => {
                        // Check for error response first
                        if (!data.success) {
                            const errorMessage = data.error || "Address validation failed";
                            console.error("USPS Address Validation Error:", errorMessage);
                            this.$toast.error(errorMessage, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: errorMessage });
                            return;
                        }

                        // Handle new USPS Addresses 3.0 API response structure
                        if (!data.result) {
                            console.error("USPS Address Validation Error: No result in response", data);
                            this.$toast.error("Invalid response from address validation service", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid response from address validation service" });
                            return;
                        }

                        const result = data.result;
                        const addressData = result.address || {};
                        const additionalInfo = result.additionalInfo || {};

                        // Check DPVConfirmation - valid values are "Y" (Confirmed), "S" (Secondary confirmed), "D" (Default confirmed)
                        // "N" (Not confirmed) is invalid
                        const validDPVConfirmations = ["Y", "S", "D"];
                        if (!validDPVConfirmations.includes(additionalInfo.DPVConfirmation)) {
                            console.error("USPS Address Validation Error: DPVConfirmation is not valid", additionalInfo);
                            this.$toast.error("Invalid ZIP Code", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid ZIP Code" });
                            return;
                        }

                        // Check if address is vacant
                        if (additionalInfo.vacant === "Y") {
                            this.$toast.warning("This address is marked as vacant", {
                                position: "top-right",
                                queue: true
                            });
                        }

                        // Show warnings if any
                        if (result.warnings && result.warnings.length > 0) {
                            result.warnings.forEach(warning => {
                                this.$toast.warning(warning.message || "Address validation warning", {
                                    position: "top-right",
                                    queue: true
                                });
                            });
                        }

                        // Validate ZIP code first - if ZIP is wrong, reject
                        const addressZip = address.zip || address.pincode || "";
                        if (addressData.ZIPCode && addressZip != addressData.ZIPCode) {
                            this.$toast.error("Invalid Zip / PostalCode", {
                                position: "top-right",
                                queue: true
                            });
                            reject({ success: false, error: "Invalid Zip / PostalCode" });
                            return;
                        }

                        // Validate state - if state is wrong, reject
                        const addressState = address.state || "";
                        if (addressData.state && addressState != addressData.state) {
                            this.state_suggestion = addressData.state;
                            this.$toast.error("Invalid State", {
                                position: "top-right",
                                queue: true
                            });
                            reject({ success: false, error: "Invalid State" });
                            return;
                        }

                        // Validate city - if city is wrong, reject
                        const addressCity = address.city || "";
                        if (addressData.city && addressCity.toLowerCase() != addressData.city.toLowerCase()) {
                            this.$toast.error("Invalid City", {
                                position: "top-right",
                                queue: true
                            });
                            reject({ success: false, error: "Invalid City" });
                            return;
                        }

                        // If ZIP code is correct but address1 doesn't match, show correction (not error)
                        const addressLine1 = address.address_line1 || address.address1 || "";
                        if (addressData.streetAddress && addressLine1.toLowerCase() != addressData.streetAddress.toLowerCase()) {
                            this.address1_suggestion = addressData.streetAddress;
                            this.$toast.info(`Address correction: ${addressData.streetAddress}`, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            // Don't reject - allow address to be saved with correction suggestion
                        }

                        // Validate Address 2 (secondaryAddress) - show correction only if content is different and meaningful
                        const addressLine2 = address.address_line2 || address.address2 || "";
                        if (addressData.secondaryAddress && addressLine2 && addressLine2.trim()) {
                            // Normalize both for comparison (trim and lowercase)
                            const userAddress2 = addressLine2.trim().toLowerCase();
                            const uspsAddress2 = addressData.secondaryAddress.trim().toLowerCase();
                            
                            // Only show suggestion if content is actually different (case-insensitive comparison)
                            // And if USPS suggestion is meaningful (not just "# R" or very short ambiguous values)
                            if (userAddress2 !== uspsAddress2) {
                                // Filter out ambiguous or very short suggestions like "# R", "#", etc.
                                const uspsTrimmed = addressData.secondaryAddress.trim();
                                const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                    !(/^#\s*[A-Z]$/i.test(uspsTrimmed)); // Don't show suggestions like "# R", "# A", etc.
                                
                                if (isMeaningfulSuggestion) {
                                    this.address2_suggestion = addressData.secondaryAddress;
                                    this.$toast.info(`Address 2 correction: ${addressData.secondaryAddress}`, {
                                        position: "top-right",
                                        queue: true,
                                        duration: 5000
                                    });
                                    // Don't reject - allow address to be saved with correction suggestion
                                }
                            }
                        }

                        // If address1 or address2 has a suggestion, don't proceed with save - keep form open
                        if (this.address1_suggestion || this.address2_suggestion) {
                            resolve({ success: true, hasSuggestions: true });
                            return;
                        }

                        // Address verified successfully
                        resolve({ success: true, hasSuggestions: false });
                    })
                    .catch((err) => {
                        console.error("[BillingAddress] USPS Address Validation Error:", err);
                        console.error("[BillingAddress] Error response:", err.response);
                        const errorMessage = (err.response && err.response.data && err.response.data.error) || err.error || err.message || "Address validation failed";
                        this.$toast.error(errorMessage, {
                            position: "top-right",
                            queue: true,
                            duration: 5000
                        });
                        reject({ success: false, error: errorMessage });
                    });
            });
        },
        resetSuggestions() {
            this.address1_suggestion = "";
            this.address2_suggestion = "";
            this.state_suggestion = "";
        },
        applyAddress1Suggestion() {
            this.currentAddress.address_line1 = this.address1_suggestion;
            this.address1_suggestion = "";
        },
        applyAddress2Suggestion() {
            this.currentAddress.address_line2 = this.address2_suggestion;
            this.address2_suggestion = "";
        },
        saveAddress() {
            this.$validator.validateAll("billingAddressForm").then(async (isValid) => {
                if (!isValid) {
                    this.$toast.error("Please fill all required fields correctly", {
                        position: "top-right"
                    });
                    return;
                }

                this.isSaving = true;
                try {
                    const verificationResult = await this.verifyAddressWithUSPS(this.currentAddress);
                    if (!verificationResult.success) {
                        return;
                    }
                    if (verificationResult.hasSuggestions || this.address1_suggestion || this.address2_suggestion) {
                        return;
                    }

                    const countryCode = (this.currentAddress.country || "US")
                        .toString()
                        .toUpperCase()
                        .substring(0, 2);

                    const addressData = {
                        first_name: this.currentAddress.fullname.split(" ")[0] || "",
                        last_name: this.currentAddress.fullname.split(" ").slice(1).join(" ") || "",
                        address1: this.currentAddress.address_line1,
                        address2: this.currentAddress.address_line2 || "",
                        city: this.currentAddress.city,
                        state: this.currentAddress.state,
                        country: countryCode,
                        pincode: this.currentAddress.zip,
                        phone: this.currentAddress.phone,
                        email: this.currentAddress.email || "",
                        address_label: this.currentAddress.company_name || "",
                        address_title: this.currentAddress.address_title || "",
                        address_type: "Default Billing Address"
                    };

                    if (this.editingAddressIndex !== null) {
                        const existingAddress = this.billingAddresses[this.editingAddressIndex];
                        if (!existingAddress || !existingAddress.id) {
                            this.$toast.error("Could not update this address. Please try again.", {
                                position: "top-right"
                            });
                            return;
                        }
                        addressData.address_id = existingAddress.id;
                        const response = await this.updateAddressInBackend(addressData);
                        if (response && response.data && response.data.address !== undefined) {
                            await this.loadBillingAddresses();
                            await this.loadBillingAddressToOrderData(existingAddress.id);
                            this.$validator.reset();
                            this.$toast.success("Address updated successfully", {
                                position: "top-right"
                            });
                            this.resetForm();
                            this.showAddressForm = false;
                            this.reloadAddressSelect = false;
                            this.$nextTick(() => {
                                this.reloadAddressSelect = true;
                            });
                        } else {
                            this.$toast.error("Unexpected response while updating address.", {
                                position: "top-right"
                            });
                        }
                    } else {
                        const response = await this.createAddressInBackend(addressData);
                        if (response && response.data && response.data.address) {
                            const newId = response.data.address.id;
                            await this.loadBillingAddresses();
                            this.selectedBillingAddressId = newId;
                            await this.loadBillingAddressToOrderData(newId);
                            this.$validator.reset();
                            this.$toast.success("Address added successfully", {
                                position: "top-right"
                            });
                            this.resetForm();
                            this.showAddressForm = false;
                            this.reloadAddressSelect = false;
                            this.$nextTick(() => {
                                this.reloadAddressSelect = true;
                            });
                        } else {
                            this.$toast.error("Unexpected response while adding address.", {
                                position: "top-right"
                            });
                        }
                    }
                } catch (err) {
                    console.error("Billing address save error:", err);
                    if (err && err.response && err.response.data) {
                        const d = err.response.data;
                        const msg =
                            typeof d.error === "string"
                                ? d.error
                                : typeof d.message === "string"
                                    ? d.message
                                    : null;
                        if (msg) {
                            this.$toast.error(msg, { position: "top-right" });
                        }
                    } else if (!err || err.success !== false) {
                        this.$toast.error("Error saving address. Please try again.", {
                            position: "top-right"
                        });
                    }
                } finally {
                    this.isSaving = false;
                }
            });
        },
        createAddressInBackend(addressData) {
            return ApiService.post("/address-book", addressData);
        },
        updateAddressInBackend(addressData) {
            return ApiService.post("/update-user-address", addressData);
        },
        addNewAddress() {
            this.resetForm();
            this.showAddressForm = true;
        },
        cancelEdit() {
            this.resetForm();
            this.showAddressForm = false;
        },
        applyCustomerDefaultsToBillingForm() {
            const pod = this.orderPayload;
            const def = this.customerProfileDefaults;
            const fn = (
                (pod && pod.firstName) ||
                (def && def.firstName) ||
                ""
            )
                .toString()
                .trim();
            const ln = (
                (pod && pod.lastName) ||
                (def && def.lastName) ||
                ""
            )
                .toString()
                .trim();
            if (fn || ln) {
                this.currentAddress.fullname = [fn, ln].filter(Boolean).join(" ");
            } else if (pod && pod.fullname) {
                this.currentAddress.fullname = pod.fullname;
            }
            const email = (pod && pod.email) || (def && def.email) || "";
            if (email) {
                this.currentAddress.email = email;
            }
            const phone = (pod && pod.phone) || (def && def.phone) || "";
            if (phone) {
                this.currentAddress.phone = phone;
            }
            this.currentAddress.country = "US";
        },
        resetForm() {
            this.currentAddress = {
                address_title: "",
                fullname: "",
                company_name: "",
                phone: "",
                email: "",
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                zip: "",
                country: "US",
                is_default: false
            };
            this.applyCustomerDefaultsToBillingForm();
            this.editingAddressIndex = null;
            this.resetSuggestions();
            this.reloadStateInput = false;
            this.reloadCountryInput = false;
            this.$nextTick(() => {
                this.reloadStateInput = true;
                this.reloadCountryInput = true;
            });
            this.$validator.reset();
        },
        loadBillingAddressToOrderData(addressId) {
            // Load full address details and save to order_data
            const _this = this;
            return this.getAddressForForm(addressId)
                .then((data) => {
                    // getAddressForForm resolves with backend body directly (e.g. { zipAndState })
                    const address = (data && (data.zipAndState || data.address)) || null;
                    if (address) {
                        // Normalize keys: API may return address_line1/address_line2/zip instead of address1/address2/pincode
                        const addr1 = address.address1 || address.address_line1 || "";
                        const addr2 = address.address2 || address.address_line2 || "";
                        const zip = address.pincode || address.zip || "";
                        // Save billing address to order_data
                        const pod = _this.orderPayload;
                        if (pod) {
                            // Billing address fields
                            pod.billingaddress1 = addr1;
                            pod.billingaddress2 = addr2;
                            pod.billingcity = address.city || "";
                            pod.billingstate = address.state || "";
                            pod.billingzip = zip;
                            pod.billingcountry = address.country || "US";
                            pod.billingphone = address.phone || "";
                            pod.billingemail = address.email || "";
                            pod.billingfullname = (address.first_name || "") + " " + (address.last_name || "");
                            pod.billingcompany = address.address_label || "";
                            pod.billing_address_id = addressId;
                            // Persist for split flow so Review & Pay can re-hydrate if needed
                            if (_this.isSplitShipment) {
                                try { localStorage.setItem("billingAddressIdSplit", String(addressId)); } catch (e) {}
                            }
                            
                            // Also set main order_data fields that PaymentShipmentV2 might need
                            pod.fullname = pod.fullname || pod.billingfullname || "";
                            pod.email = pod.email || address.email || "";
                            pod.phone = pod.phone || address.phone || "";
                            
                            // Set billing address fields in standard format (for compatibility)
                            pod.address1 = addr1;
                            pod.address2 = addr2;
                            pod.city = address.city || "";
                            pod.addressstate = address.state || "";
                            pod.addresszip = zip;
                            pod.billingcountry = address.country || "US";
                            pod.billingaddressid = addressId;
                            pod.billing_first_name = address.first_name || "";
                            pod.billing_last_name = address.last_name || "";
                        }
                    }
                })
                .catch(() => {});
        },
        validateBillingAddress() {
            // Validate that a billing address is selected
            if (!this.selectedBillingAddressId) {
                this.$toast.error("Please select a billing address before proceeding", {
                    position: "top-right",
                    queue: true
                });
                return false;
            }
            return true;
        }
    }
};
</script>

<style scoped>
.billing-address {
    padding: 20px 0;
}

.billing-address .heading1 {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    color: #121212;
    margin-bottom: 4px;
}

/* Billing address selection block - underlined dropdown & link (Figma/screenshot) */
.billing-address-section h3 {
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    color: #121212;
    margin-bottom: 16px;
}

.billing-address-section .form-group .select_option_label {
    font-size: 14px;
    font-weight: 400 !important;
    color: #6B7280;
    margin-bottom: 8px;
    margin-bottom: 0px !important;
}
.billing-address .billing-address-section .form-group{
    margin: 12px 0px 12px 0px;
}
.billing-address-section .choose_billing_address :deep(.v-select .vs__dropdown-toggle) {
    border: none !important;
    border-bottom: none !important;
    border-radius: 0;
    background: #fff;
    min-height: 40px;
    padding: 0px;
    box-shadow: none !important;
    margin-top: 7px;
}

.billing-address-section :deep(.v-select .vs__selected) {
    margin: 0;
    padding-left: 0;
}

.billing-address-section :deep(.v-select .vs__selected),
.billing-address-section :deep(.v-select .vs__search) {
    font-size: 16px;
    line-height: 22.4px;
    color: #333333;
    font-weight: 400;
}

.billing-address-section :deep(.v-select .vs__search) {
    padding-left: 0;
}

.billing-address-section .btn.btn-link.text_primary_blue {
    font-size: 14px !important;
    color: #0079C1 !important;
    line-height: 14px;
    letter-spacing: 0px;
    font-weight: 400;
    text-transform: capitalize;
}

.billing-address-section .btn.btn-link.text_primary_blue:hover {
    color: #0079C1 !important;
    text-decoration: underline;
}

.billing-address .address-form-section {
    border: 1px solid #B6B6B6;
    padding: 16px;
}

.billing-address .white_box .address-form-section label {
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    margin-bottom: 12px !important;
    font-weight: 500 !important;
    position: static;
}
.billing-address .form-group{
    margin: 24px 0px 12px 0px;
}
.billing-address .form-group.label-const {
    position: relative;
    margin-top: 16px;
}

.billing-address .form-group.label-const .form-control {
    padding: 10px 12px;
}

.billing-address .form-group.label-const .highlight {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #1d6cb5;
    transition: width 0.3s;
}

.billing-address .form-group.label-const .form-control:focus ~ .highlight {
    width: 100%;
}

.billing-address .address-form-section textarea {
    resize: vertical;
}

.billing-address .address-form-section .form-control:focus,
.billing-address .address-form-section textarea:focus {
    border-color: #1D6CB5;
    box-shadow: 0 0 0 1px rgba(29, 108, 181, 0.2);
}

.billing-address .address-form-section .v-select .vs__dropdown-toggle {
    border: 1px solid #D1D5DB;
    border-radius: 2px;
    min-height: 40px;
    padding: 6px 10px;
}

.billing-address .address-form-section .v-select .vs__selected,
.billing-address .address-form-section .v-select .vs__search {
    font-size: 14px;
    line-height: 20px;
    color: #121212;
}

.billing-address .select_option_label {
    font-weight: 700 !important;
    top: 9px !important;
    margin-top: 0px !important;
    position: relative;
    font-size: 14px;
    color: #000;
    margin-bottom: 10px;
}

.billing-address .select_option_label.bill_state {
    top: -22px !important;
}

.billing-address .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.billing-address .btn_outline_primary {
    background-color: transparent;
    border: 1px solid;
}

.billing-address .border_primary_blue {
    border-color: #1d6cb5 !important;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #1D6CB5;
    max-width: 120px;
    font-size: 16px;
    line-height: 20px;
    color: #1D6CB5;
    font-weight: 600;
    padding: 12px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.billing-address .py_18 {
    padding-top: 18px;
    padding-bottom: 18px;
}

.billing-address .px_46 {
    padding-left: 46px;
    padding-right: 46px;
}

.billing-address .px_64 {
    padding-left: 64px;
    padding-right: 64px;
}

.billing-address .btn_orange {
    border: none;
}

.billing-address .bg_primary_orange {
    background-color: #F2790C;
}

.billing-address .text_white {
    color: #ffffff;
}

.billing-address .btn.bg_primary_orange.text_white {
    min-width: 130px;
    height: 40px;
    padding: 0 20px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}




.order-comment-section {
    margin-top: 30px;
    padding-top: 20px;
    /* border-top: 1px solid #e9ecef; */
}

.order-comment-section textarea {
    min-height: 70px;
    max-height: 70px;
    border: 1px solid #707070 !important;
    margin-top: 16px;
}
</style>

<style>
.billing-address .white_box .address-form-section .form-control,
.billing-address .white_box .address-form-section textarea.form-control,
.billing-address .white_box .address-form-section .vs__search {
    border: 1px solid #33333380 !important;
    border-radius: 2px !important;
    padding: 8px 10px !important;
    min-height: 40px;
    height: 40px;
    font-size: 14px;
    line-height: 20px;
    color: #121212;
    box-shadow: none;
    margin: 0px !important;
}
.billing-address .shipping_fl_left .vs__selected-options .vs__selected {
    top: 10px;
}
.billing-address .white_box .address-form-section .vs__selected {
    margin: 0px;
    padding-left: 10px;
}
.billing-address .white_box .address-form-section .form-group {
    margin-top: 16px;
}
.billing-address .white_box .address-form-section .vs__selected-options input {
    background-position: 95% 50% !important;
}
.save-width {
    width: fit-content !important;
}
.order-comment-section p{
    color: #2C2C2C;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
}
.billing-address .white_box {
    padding: 24px 32px 24px 32px !important;
}
 .billing-address  .billing-address-section input{
    height: 34px;
}
 .billing-address  .billing-address-section .vs__selected{
    top: 10px;
}

@media (max-width: 991px) {
    .billing-address {
        padding: 16px 0;
    }

    .billing-address .white_box {
        padding: 24px 20px !important;
    }

    .billing-address .heading1 {
        font-size: 22px;
        line-height: 30px;
    }

    .billing-address .address-form-section {
        padding: 14px;
    }

    .billing-address .form-group {
        margin: 16px 0 10px 0;
    }

    .billing-address .order-comment-section textarea {
        min-height: 90px;
        max-height: 140px;
    }
}

@media (max-width: 767px) {
    .billing-address .white_box {
        padding: 20px 14px !important;
    }

    .billing-address .heading1 {
        font-size: 20px;
        line-height: 28px;
    }

    .billing-address-section h3 {
        font-size: 17px;
        line-height: 24px;
        margin-bottom: 12px;
    }

    .billing-address .address-form-section .row > [class*="col-"] {
        margin-bottom: 4px;
    }

    .billing-address .select_option_label.bill_state {
        top: 0 !important;
    }

    .billing-address .form-actions {
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .billing-address .border_primary_blue,
    .billing-address .btn.bg_primary_orange.text_white {
        min-width: 140px;
    }

    .billing-address .order-comment-section {
        margin-top: 22px;
        padding-top: 14px;
    }

    .billing-address .order-comment-section p {
        font-size: 15px;
        line-height: 22px;
    }
}

@media (max-width: 575px) {
    .billing-address .white_box {
        padding: 16px 12px !important;
    }

    .billing-address .heading1 {
        font-size: 18px;
        line-height: 24px;
    }

    .billing-address-section .choose_billing_address :deep(.v-select .vs__dropdown-toggle) {
        min-height: 36px;
    }

    .billing-address-section :deep(.v-select .vs__selected),
    .billing-address-section :deep(.v-select .vs__search) {
        font-size: 14px;
        line-height: 20px;
    }

    .billing-address .address-form-section {
        padding: 12px;
    }

    .billing-address .white_box .address-form-section .form-control,
    .billing-address .white_box .address-form-section textarea.form-control,
    .billing-address .white_box .address-form-section .vs__search {
        font-size: 13px;
    }

    .billing-address .form-actions {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }

    .billing-address .form-actions .btn,
    .billing-address .border_primary_blue,
    .billing-address .btn.bg_primary_orange.text_white {
        width: 100%;
        max-width: 100%;
    }

    .billing-address .border_primary_blue,
    .billing-address .btn.bg_primary_orange.text_white {
        min-width: 100%;
        font-size: 14px;
    }

    .billing-address .order-comment-section textarea {
        min-height: 84px;
    }
}
</style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        